module.exports = __webpack_public_path__ + "media/media/service/multiplatform-f8f345be1080362fa66f4ffbe2d3acc9.png";